import styled from 'styled-components';
import { Button } from '@dsny/dsny-component-library';
import theme from 'src/styles/theme';
import { device } from 'src/styles/global';

export const HeadingImportReleaseModal = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  color: ${theme.colors.neutralW20};
  margin-bottom: 8px;
`;

export const TextImportReleaseModal = styled.p`
  font-size: 14px;
  line-height: 19px;
  color: ${theme.colors.neutralW40};
  margin-bottom: 24px;
`;

export const SubTextImportReleaseModal = styled.p`
  font-size: 14px;
  line-height: 19px;
  color: ${theme.colors.neutralW40};
  margin-bottom: 32px;

  @media ${device.mobile} {
    margin-bottom: 24px;
  }
`;

export const ReleaseAndArtistWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 90px;
  overflow-y: auto;
  gap: 4px;
  margin-bottom: 32px;
  position: relative;
  padding-right: 8px;
  scrollbar-gutter: stable both-edges;

  @media ${device.mobile} {
    margin-bottom: 24px;
  }

  /* hide scrollbar cross-browser */
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* chevron hint */
  &::after {
    content: '▾';
    position: absolute;
    right: 8px;
    bottom: 4px;
    font-size: 14px;
    line-height: 1;
    color: ${theme.colors.neutralW40};
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
  }

  /* show chevron only when there are enough items to overflow (~5+) */
  @supports selector(:has(*)) {
    &:has(> *:nth-child(n + 5))::after {
      opacity: 0.7;
    }
  }

  @media (hover: hover) {
    &:hover::after,
    &:focus-within::after,
    &:active::after {
      opacity: 0;
    }
  }
`;

export const ReleaseAndArtistStyle = styled.p`
  font-size: 14px;
  color: ${theme.colors.neutralW40};
`;

export const ReleaseImageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 32px;

  @media ${device.mobile} {
    margin-bottom: 24px;
  }
`;

export const FlexButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
`;

export const ButtonStyleWrapper = styled(Button)`
  width: 'fit-content';
  height: 36px;
  border-radius: 5px;
`;
